export default __webpack_public_path__ + "static/media/screenshot.c3182ce0.png";